var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrollPreloader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 41,
    viewBox: "0 0 45 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2687 23.5946C21.603 25.2051 24.3367 25.6678 27.173 25.2885C30.0093 24.9093 32.5903 23.4939 34.3907 21.3306C36.1911 19.1673 37.0755 16.4186 36.8639 13.6442C36.6523 10.8698 35.3605 8.27811 33.2516 6.39684C31.1426 4.51557 28.3751 3.4861 25.5123 3.51801C22.6495 3.54993 19.9067 4.64082 17.8423 6.56861C15.7779 8.4964 14.547 11.1162 14.4002 13.8946C14.2534 16.673 15.2018 19.4013 17.0523 21.5239L18.2527 20.3808C16.7015 18.6015 16.0951 16.3141 16.2181 13.9851C16.3411 11.656 17.3729 9.45995 19.1035 7.84395C20.834 6.22796 23.1332 5.3135 25.533 5.28675C27.9327 5.26 30.2527 6.12297 32.0205 7.69997C33.7884 9.27697 34.8712 11.4495 35.0486 13.7752C35.226 16.1009 34.4846 18.405 32.9754 20.2184C31.4662 22.0318 29.3026 23.2183 26.925 23.5362C24.5475 23.8541 22.5664 23.5032 20.6096 22.1532L19.2687 23.5946Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1033 6.70879C21.2787 7.61179 19.7429 8.98256 18.6622 10.6727L20.2047 11.6039C21.1105 10.1872 22.3978 9.03821 23.9273 8.2813L23.1033 6.70879Z",
    fill: "#DFAF7A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0735426 35.3708L17.8148 20.0352L18.1869 20.27L3.65113 36.094L0.934858 39.2587L0.0735426 35.3708Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollPreloader);
export default __webpack_public_path__ + "static/media/scroll-preloader.f58a2eb187c5f886ba9b1ecb14ceb90f.svg";
export { ForwardRef as ReactComponent };